import { NavLink } from "react-router-dom";
import * as FaIcons from 'react-icons/fa';
import * as GoIcons from "react-icons/go";
import * as RiIcons from "react-icons/ri";
import * as MdIcons from "react-icons/md";
import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <RiIcons.RiDashboardFill />,
  },
  {
    path: "/mngusers",
    name: "Manage Users",
    icon: <FaIcons.FaUsersCog />,
  },
  {
    path: "/verifyusers",
    name: "Verify Users",
    icon: <GoIcons.GoUnverified />,
  },
  {
    path: "/mngbookings",
    name: "Manage Bookings",
    icon: <MdIcons.MdLibraryBooks />,
  },
  {
    path: "/settings",
    name: "Account Settings",
    icon: <FaIcons.FaUserCog />,
    exact: true,
    subRoutes: [
      {
        path: "/profile",
        name: "Profile ",
        icon: <FaIcons.FaUser />,
      },
      {
        path: "/changepass",
        name: "Change Password",
        icon: <MdIcons.MdPassword />,
      },
    ],
  },
];

const SideBar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.6,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.4,
      },
    },
  };

  return (
    <>
      <div className="main-container">
        <motion.div
          animate={{
            width: isOpen ? "220px" : "50px",

            transition: {
              duration: 0.6,
              type: "spring",
              damping: 10,
            },
          }}
          className={`sidebar `}
        >
          <div className="top_section">
            <AnimatePresence>
              {isOpen && (
                <motion.h2
                  variants={showAnimation}
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  className="logo"
                >
                  MentorWayz
                </motion.h2>
              )}
            </AnimatePresence>

            <div className="bars">
              <FaIcons.FaBars onClick={toggle} />
            </div>

          </div>

          <section className="routes">
            {routes.map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <NavLink
                  to={route.path}
                  key={index}
                  className="link"
                  activeclassname="active"
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
              );
            })}
          </section>
        </motion.div>

        <main>{children}</main>
      </div>
    </>
  );
};

export default SideBar;